import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 max-w-[1440px] mx-auto">
          <Link
            to="/"
            className="flex items-center gap-2 whitespace-nowrap cursor-pointer"
          >
            <span className="text-2xl font-heading font-bold text-foreground-900">
              韩漫网
            </span>
            <span className="hidden sm:inline text-xs text-foreground-500 font-sans">
              hanmanwang.com
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 text-sm rounded-lg transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/'
                  ? 'text-primary-600 font-semibold bg-primary-50'
                  : 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100'
              }`}
            >
              首页
            </Link>
            <Link
              to="/category/all"
              className={`px-4 py-2 text-sm rounded-lg transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname.startsWith('/category')
                  ? 'text-primary-600 font-semibold bg-primary-50'
                  : 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100'
              }`}
            >
              分类浏览
            </Link>
            <Link
              to="/about"
              className={`px-4 py-2 text-sm rounded-lg transition-colors whitespace-nowrap cursor-pointer ${
                location.pathname === '/about'
                  ? 'text-primary-600 font-semibold bg-primary-50'
                  : 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className="relative">
              <input
                type="text"
                placeholder="搜索漫画..."
                className="pl-9 pr-4 py-2 text-sm bg-background-100 border border-background-200/70 rounded-lg w-48 focus:w-64 transition-all duration-300 focus:outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 text-foreground-800 placeholder-foreground-400"
              />
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm w-4 h-4 flex items-center justify-center"></i>
            </div>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden p-2 rounded-lg text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
            aria-label="菜单"
          >
            <span className="w-5 h-5 flex items-center justify-center">
              {mobileOpen ? (
                <i className="ri-close-line text-xl"></i>
              ) : (
                <i className="ri-menu-line text-xl"></i>
              )}
            </span>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden bg-background-50 border-t border-background-200/70 animate-fadeInUp">
            <div className="px-4 py-4 space-y-1">
              <Link
                to="/"
                className={`block px-4 py-3 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === '/'
                    ? 'text-primary-600 bg-primary-50'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                首页
              </Link>
              <Link
                to="/category/all"
                className={`block px-4 py-3 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname.startsWith('/category')
                    ? 'text-primary-600 bg-primary-50'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                分类浏览
              </Link>
              <Link
                to="/about"
                className={`block px-4 py-3 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname === '/about'
                    ? 'text-primary-600 bg-primary-50'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                关于我们
              </Link>
              <div className="pt-2">
                <div className="relative">
                  <input
                    type="text"
                    placeholder="搜索漫画..."
                    className="w-full pl-9 pr-4 py-2.5 text-sm bg-background-100 border border-background-200/70 rounded-lg focus:outline-none focus:border-primary-300 text-foreground-800 placeholder-foreground-400"
                  />
                  <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm w-4 h-4 flex items-center justify-center"></i>
                </div>
              </div>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}